import { render } from "./NotificationsOrder.vue?vue&type=template&id=47efcd1e"
import script from "./NotificationsOrder.vue?vue&type=script&lang=js"
export * from "./NotificationsOrder.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__